import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import TruckIcon from "resources/svg-images/TruckIcon";
import HideIf from "util/HideIf";
import styles from "../shipping-check/shippingCheckEstimator.module.scss";

const ShippingCheckEstimatorContent = dynamic(() => import(/* webpackChunkName: "shipping-content" */"../shipping-check/ShippingCheckEstimatorContent"));

function EnterPostalCode({ orderSummary = false }) {
  const { t } = useTranslation("shopping-cart");
  const { postalCode, ipLocation } = useSelector((state: RootState) => state.shoppingCart);
  const isUserLocationPresent = postalCode || ipLocation;

  if (isUserLocationPresent) {
    return null;
  }

  return (
    <div className={classNames(styles.enter_postal_code_container, {
      [styles.enter_postal_code_container_summary]: orderSummary,
    })}
    >
      <HideIf show={!orderSummary}>
        <TruckIcon />
      </HideIf>

      <div className={classNames("d-flex flex-column", {
        "m-l-10": !orderSummary,
      })}
      >
        <PAText className={styles.no_postal_code_text} bold fontSize={FONT_SIZE[0]}>
          {t("Enter postal code to calculate taxes")}
        </PAText>
        <PAText className={styles.enter_postal_code_text} color="black" fontSize={FONT_SIZE[0]}>
          {t("Postal code is required to determine applicable taxes")}
        </PAText>
      </div>
      <HideIf show={orderSummary}>
        <div>
          <ShippingCheckEstimatorContent classNameCard={styles.estimator_content} />
        </div>
      </HideIf>
    </div>
  );
}

export default EnterPostalCode;
